import React from 'react'

export default ({ errors = [] }) => {
  if (errors.length === 0) {
    return null
  }

  return (
    <div className="help-block error">{errors.join(", ")}</div>
  )
}
